import { GET_CHECKUSER_IDENTIFIER } from "api/api";
import { useEffect } from "react";
import { useFetch } from "./useFetch";

export const useCheckUserIdentifier = (userId, { onDone } = {}) => {
  const url = userId
    ? GET_CHECKUSER_IDENTIFIER(userId)
    : null;

  const { D, L, E, mutate } = useFetch({
    url,
    // file: "check-user-identifier",
    done: (data) => {
      if (data) onDone?.(data);
    },
  });

  // Automatically refetch when userId changes
  useEffect(() => {
    if (userId && mutate) mutate();
  }, [userId]);

  return { data: D, loading: L, error: E };
};
